import mutations from './mutations'
import actions from './action'
import getters from './getters'


const state = {
	stores:[],
}

export default {
	state,
 	getters,
  	actions,
  	mutations,
}